<-- 市场合作页面 -->
<template>
    <div class="w100">
        <div  class="w100 pos_re">
            <img src="../../static/img/index/cooperation_banner.png" class="w100 banner_img">
            <div class="banner">
                <div class="dis_column just_cen banner_con">
                    <p style="font-weight: bold;">平台化发展，携手共赢</p>
                    <p class="banner_con_des">我们为众多合作伙伴提供综合三网平台、市场和营销支持、业务支持以及售后支持，帮助代理商取得更优渥的回报。</p>
                </div>
            </div>
        </div>
        <div class="w100">
            <div class="content" style="margin-top:5vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">代理产品</p>
                    <p class="con_title_des">Agent products</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_cen margin_top_2 flex_wrap" style="width:60vw">
                        <div class="agent_item dis_column just_cen ali_cen" v-for="(item,index) in agentList" :key="index">
                            <div class="agent_item_img dis_column just_cen ali_cen">
                                <img :src=item.icon :class="[item.text == '号码认证'?'width_3':'']">
                            </div>
                            <p>{{item.text}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w100 pos_re" style="margin-top:5vw">
                <img src="../../static/img/index/cooperation_process.png" class="cooperation_process_img" >
                <div class="cooperation_process_div dis_column ali_cen">
                    <p class="cooperation_process_title con_title">合作流程</p>
                    <p class="con_title_des" style="color:#fff">Cooperation process</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="cooperation_process_item1 dis_column ali_cen just_cen">
                        <p class="cooperation_process_item_title">合作申请</p>
                        <p class="cooperation_process_item_text">有意向合作的伙伴可通过我司官网上面的联系方式联系我们提交合作申请。</p>
                    </div>
                    <div class="cooperation_process_item2 dis_column ali_cen just_cen">
                        <p class="cooperation_process_item_title">合作评估</p>
                        <p class="cooperation_process_item_text">我司会根据意向合作伙伴提供的资料进行评估，须有良好的商业操守，职业道德。</p>
                    </div>
                    <div class="cooperation_process_item3 dis_column ali_cen just_cen">
                        <p class="cooperation_process_item_title">正式代理</p>
                        <p class="cooperation_process_item_text">我司根据合作伙伴提供的资料进行评估，评估通过正式成为代理商。</p>
                    </div>
                    <div class="cooperation_process_item4 dis_column ali_cen just_cen">
                        <p class="cooperation_process_item_title">合作签约</p>
                        <p class="cooperation_process_item_text">我司与合作伙伴签订渠道合作协议，需接受代理合约中规定的各项条款。</p>
                    </div>
                </div>
            </div>
            <div class="content" style="margin-top:5vw;margin-bottom:10vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">代理支持</p>
                    <p class="con_title_des">Partners support</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_bet" style="width:70vw;margin-top:5vw;">
                        <div class="support_item dis_column just_cen ali_cen" v-for="(item,index) in supportList" :key="index">
                            <div class="support_item_img dis_column just_cen ali_cen">
                                <img :src=item.icon >
                            </div>
                            <p>{{item.text}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {titleList} from '../assets/js/global.js'
export default {       
    name: 'ringone',
    data () {
        return {
            agentList:[{
                icon:'../../static/img/index/daili1.png',
                text:'企业彩铃'
            },{
                icon:'../../static/img/index/daili2.png',
                text:'视频彩铃'
            },{
                icon:'../../static/img/index/daili3.png',
                text:'号码认证'
            },{
                icon:'../../static/img/index/daili4.png',
                text:'400电话'
            },{
                icon:'../../static/img/index/daili5.png',
                text:'视频制作'
            },{
                icon:'../../static/img/index/daili6.png',
                text:'彩铃录音'
            }],
            supportList:[{
                icon:'../../static/img/index/case1.png',
                text:'售前支持'
            },{
                icon:'../../static/img/index/case2.png',
                text:'营销支持'
            },{
                icon:'../../static/img/index/case3.png',
                text:'售后服务'
            },{
                icon:'../../static/img/index/case4.png',
                text:'能力提升'
            }]
        }
    },
    created(){
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.$root.indexTabFlag = 0
        titleList(this.$root.indexTabList,2)
    },
    mounted () {
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods:{
        scrollToTop(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if(scrollTop > 100){
            this.$root.indexTabFlag = 1
            }else{
            this.$root.indexTabFlag = 0
            }
        }
    }
}
</script>

<style scoped>
    .banner_img{
        width: 100%;
        height: 28vw;
    }
    .banner{
        position: absolute;
        top: 3.4vw;
        left: 0;
        width: 100%;
        height: 24.6vw;
    }
    .banner_con{
        width: 70vw;
        height: 24vw;
        margin: 0 auto;
        color: #fff;
        font-size: 3vw;
    }
    .banner_con_des{
        width: 35vw;
        line-height: 1.8vw;
        font-size: 1vw;
        margin-top:2vw;
    }
    .video{
        object-fit:fill;width:50vw;
        margin: 0 auto;
    }
    .pop{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2vw;
        background: #fff;
    }
    .agent_item{
        width: 15vw;
        height: 12vw;
        transition: all 0.3s linear 0s;
    }
    .support_item{
        width: 14vw;
        height: 14vw;
        transition: all 0.3s linear 0s;
    }
    .agent_item:hover{
        box-shadow: 0px 0px 32px -24px;
        transform: scale(1.02);
    }
    .support_item:hover{
        transform: scale(1.02);
        border: 1px solid #2365d3;
    }
    .agent_item_img{
        width: 4vw;
        height: 4vw;
    }
    .support_item_img{
        width: 8vw;
        height: 8vw;
    }
    .support_item_img img,.agent_item_img img{
        width: 100%;
        max-height: 100%;
    }
    .agent_item p,.support_item p{
        font-size: 1.1vw;
        font-weight: bold;
        margin-top: 0.8vw;
        color: rgb(102, 102, 102);
    }
    .support_item p{
        margin-top: 1.5vw;
    }
    .width_3{
        width: 3.5vw !important;
    }
    .cooperation_process_img,cooperation_process_div{
        width: 100vw;
        height: 45vw;
    }
    .cooperation_process_div{
        width: 70vw;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -35vw;
    }
    .cooperation_process_title{
        margin-top: 4vw;
        color: #fff;
    }
    .cooperation_process_item1,.cooperation_process_item2,.cooperation_process_item3,.cooperation_process_item4{
        width: 10vw;
        height: 6vw
    }
    .cooperation_process_item1{
        position: absolute;
        left: 7vw;
        top: 27vw;
    }
    .cooperation_process_item2{
        position: absolute;
        left: 21vw;
        top: 16vw;
    }
    .cooperation_process_item3{
        position: absolute;
        left: 39vw;
        top: 16vw;
    }
    .cooperation_process_item4{
        position: absolute;
        left: 53vw;
        top: 27vw;
    }
    .cooperation_process_item_title{
        font-size: 1.3vw;
        color: #ffcf12;
    }
    .cooperation_process_item_text{
        font-size: 0.7vw;
        color: #ffffff;
        text-align: center;
        margin-top:0.8vw
    }
</style>



// WEBPACK FOOTER //
// src/components/Cooperation.vue